import AiFieldFillSettingsAPI from '../../api/aiFieldFillSettings';

// Holds the account's AI Field Fill trigger settings so the manual "Fill with AI"
// trigger can gate on `manual_enabled` without every button instance fetching.
// Only fetched when the feature flag is on (the settings row materializes
// lazily server-side — fetching for a non-feature account would create it).
const state = {
  manualEnabled: false,
  uiFlags: { isFetching: false, isFetched: false },
};

const getters = {
  getManualEnabled: $state => $state.manualEnabled,
  getUIFlags: $state => $state.uiFlags,
};

const mutations = {
  SET_UI_FLAG(currentState, flags) {
    currentState.uiFlags = { ...currentState.uiFlags, ...flags };
  },
  SET_MANUAL_ENABLED(currentState, value) {
    currentState.manualEnabled = value;
  },
};

const actions = {
  // Concurrent-safe: the two trigger instances (conversation + contact) mount
  // together, so a fetch already in flight is reused instead of duplicated. A
  // fresh mount (e.g. account switch) re-fetches, keeping it current.
  async get({ commit, state: currentState }) {
    if (currentState.uiFlags.isFetching) return;
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const { data } = await AiFieldFillSettingsAPI.get();
      commit('SET_MANUAL_ENABLED', data.manual_enabled === true);
      commit('SET_UI_FLAG', { isFetched: true });
    } catch (error) {
      // Leave manualEnabled false on failure — the trigger simply stays hidden.
      // Log so the degraded state is not swallowed silently.
      // eslint-disable-next-line no-console
      console.error('Failed to load AI field fill settings', error);
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
